import {Component, OnInit} from '@angular/core';
import environment from '../../../../environment';

@Component({
  selector: 'OldLeisure',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  standalone: false,
})
export class OldLeisureComponent implements OnInit {
  ngOnInit(): void {
    if (environment.settings.verboseLogging) {
      console.log('TestComponent has been initialized');
    }
  }
}
